export const hero = {
  title: 'Importazione diretta di attrezzature per palestra',
  subtitle: 'Prodotto su ordinazione',
  button: 'Vedi Prodotti'
};

export const product = {
  specs: 'Specifiche',
  weight: 'Peso',
  volume: 'Volume',
  onRequest: 'Su Richiesta'
};

export const total = {
  label: 'VALORE TOTALE',
  onRequest: 'Su Richiesta'
};

export const delivery = {
  shipping: {
    label: 'PREVISIONE DI SPEDIZIONE',
    value: '30 Giorni',
    description: 'Dopo il ricevimento del deposito'
  },
  delivery: {
    label: 'PREVISIONE DI CONSEGNA',
    value: '60 Giorni',
    description: 'Dopo la spedizione delle attrezzature'
  },
  packaging: {
    label: 'IMBALLAGGIO',
    value: 'Compensato',
    description: 'Scatola di legno compensato'
  },
  warranty: {
    label: 'GARANZIA',
    value: '1 Anno',
    description: 'Pezzi di ricambio gratuiti',
    note: '(non include le spese di spedizione dei pezzi)'
  },
  manufacturer: {
    label: 'PRODUTTORE',
    value: 'BRTW',
    link: 'Visita il sito'
  }
};

export const financial = {
  title: 'VALORE TOTALE (BRL)',
  installment1: {
    title: 'Rata 1 — Avviare il processo',
    description: '30% per avviare la produzione'
  },
  installment2: {
    title: 'Rata 2 — Rilascio della spedizione',
    description: 'Pagamento del prodotto per il rilascio'
  },
  installment3: {
    title: 'Rata 3 — Arrivo a destinazione',
    description: 'Porto o aeroporto'
  }
};

export const considerations = {
  title: 'Considerazioni sulla Proposta',
  validity: 'Validità della proposta: 15 giorni',
  deadline: 'Termine di spedizione: Le attrezzature devono essere spedite entro 3 mesi. Dopo questo periodo, il contratto sarà considerato non valido.',
  observation: 'Nota: Trattandosi di un\'importazione diretta di 10 attrezzature, qualsiasi sostituzione o inclusione di nuovi articoli comporterà un ricalcolo dei valori.',
  assembly: 'Montaggio e manutenzione tecnica: Non inclusi (responsabilità dell\'acquirente).'
};

export const actions = {
  print: 'Stampa',
  download: 'Scarica PDF',
  whatsapp: 'Invia tramite WhatsApp',
  email: 'Invia tramite E-mail',
  whatsappText: 'Ciao! Ecco la proposta commerciale di Moviis:',
  emailSubject: 'Proposta Commerciale Moviis',
  emailBody: 'Ciao! Ecco la proposta commerciale di Moviis:'
};

export const contact = {
  meeting: {
    title: 'Programma una Riunione',
    button: 'Programma Ora'
  },
  email: {
    title: 'Contattaci',
    button: 'Invia E-mail'
  }
};

export const footer = {
  description: 'Attrezzature professionali per palestra ad alte prestazioni.',
  equipment: {
    title: 'Attrezzature',
    cardio: 'Cardio',
    strength: 'Muscolazione',
    functional: 'Funzionale'
  },
  info: {
    title: 'Informazioni',
    catalog: 'Catalogo',
    shipping: 'Spedizione 30 giorni',
    delivery: 'Consegna 60 giorni',
    warranty: 'Garanzia 1 anno'
  },
  contactInfo: {
    title: 'Contatto',
    address: 'R. Voluntários da Pátria, n.º 2468, 6º piano',
    zipcode: 'CAP 02402-000',
    phone: '(11) 3255-2877',
    email: 'lp@moviis.com.br',
    hours: 'Lunedì a venerdì, 08:30 alle 18:00 (GMT -03:00)'
  },
  copyright: '© 2026 Moviis. Tutti i diritti riservati.',
  poweredBy: 'Powered by Readdy'
};

export default {
  'hero.title': hero.title,
  'hero.subtitle': hero.subtitle,
  'hero.button': hero.button,
  'product.specs': product.specs,
  'product.weight': product.weight,
  'product.volume': product.volume,
  'total.label': total.label
};